import { Notiz } from 'sharedTypes/notiz';
import { FirebaseService } from './services/firebase.service';
import { StateService } from './services/state.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { routerTransition } from './core/animations/router.transition';
import { AuthService } from './services/auth.service';
import { GlobalService } from './services/global.service';
import { environment as env } from '../environments/environment';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CreatePdrAccountComponent } from './features/leads/create-pdr-account/create-pdr-account.component';
import { EditNotizComponent } from './shared/edit-notiz/edit-notiz.component';
import { CopyAccountDataComponent } from './features/clients/copy-account-data/copy-account-data.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [routerTransition],
    standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
    showCallList = true;
    navigation = [
        { link: 'clients', label: 'Kunden', icon: 'group' },
        { link: 'tickets', label: 'Tickets', icon: 'checklist_rtl' },
        { link: 'featureRequests', label: 'Features', icon: 'cake' },
        { link: 'leads', label: 'Kontakte', icon: 'account_box' },
        // { link: 'knowledge', label: 'Doku', icon: 'school' },
        { link: 'termine', label: 'Termine', icon: 'calendar_today' },
    ];
    navigationSideMenu = [...this.navigation, { link: 'settings', label: 'Settings' }];

    constructor(
        public authService: AuthService,
        public stateService: StateService,
        public firebaseService: FirebaseService,
        private glo: GlobalService,
        private dialog: MatDialog,
    ) {
        const intFrameWidth = window.innerWidth;
        if (intFrameWidth < 600) {
            this.showCallList = false;
        }
    }

    ngOnInit(): void {
        this.firebaseService.admin.subscribe((a) => {
            if (!a) {
                return;
            }
            if (this.stateService.subsStarted) {
                return;
            }
            if (a && a.isSupport) {
                this.stateService.startSubs();
            }
        });
    }

    ngOnDestroy(): void {}

    onReload() {
        window.location.reload();
    }

    async onLogoutClick() {
        this.glo.startLoading('Abmelden');
        await this.firebaseService.saveAdminAction('logout');
        this.stateService.stopAllSubs().then(async (fertig: any) => {
            await this.authService.logout();
            this.glo.endLoading();
        });
    }

    async loginWithMicrosoft() {
        await this.authService.loginWithMicrosoft();
    }

    askCreateAccount() {
        const cfg = new MatDialogConfig();
        cfg.width = '600px';
        cfg.data = cfg.data = {
            leadId: '',
            email: '',
        };
        const dialogRef = this.dialog.open(CreatePdrAccountComponent, cfg);
        dialogRef.afterClosed().subscribe(() => {
            // console.log('The dialog was closed');
        });
    }

    openAccountCopy() {
        const cfg = new MatDialogConfig();
        cfg.width = '600px';
        cfg.data = cfg.data = {
            leadId: '',
            email: '',
        };
        const dialogRef = this.dialog.open(CopyAccountDataComponent, cfg);
        dialogRef.afterClosed().subscribe(() => {
            // console.log('The dialog was closed');
        });
    }

    async editTeamNews() {
        const cfg = new MatDialogConfig();
        cfg.width = '600px';
        const notiz = new Notiz();
        notiz.text = this.stateService.sharedSettings.getValue().teamNews || '';
        cfg.data = { notiz, onlyText: true, standAlone: true };
        const dialogRef = this.dialog.open(EditNotizComponent, cfg);
        const res = await dialogRef.afterClosed().toPromise();
        if (res && res.text) {
            this.firebaseService.setTeamNews(res.text);
        }
    }

    sanitizeData() {
        this.firebaseService.sanitizeData();
    }
    importAll() {
        this.firebaseService.requestImportAllAccounts();
    }
}
